export const ACTION_TYPES = {
  UPDATE_PLAY_SOURCE: 'player/UPDATE_PLAY_SOURCE',
};

// Update play source
export const updatePlaySource = (playSource) => ({
  type: ACTION_TYPES.UPDATE_PLAY_SOURCE,
  payload: playSource,
});
